var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataBox"},[_c('span',[_vm._v("您的申请初审被拒绝，请重新修改审核资料")]),_c('br'),_vm._v(" "),_c('p',{staticClass:"dataP"},[_vm._v("原因："+_vm._s(_vm.primary_mark))]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-top":"10px"},attrs:{"type":"warning"},on:{"click":_vm.submitAgain}},[_vm._v("重新修改")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d14dc6b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/joinprocess/processDataexamine3.vue
// module id = null
// module chunks = 